<!--

Simple component for linking. Designed to be used as a div you can
click on. Updates the vue-router using route="" or go to an
external url (or static asset like a pdf) using url=""

Can be styled any way you want via a class="".

Optional:  todo

Sample usage:

//router
<link-box route="/w9-forms">
    W9 Forms
</link-box>

//external url
<link-box url="http://www.w9forms.com">
    W9 Forms
</link-box>

-->

<template>
  <div class="container">
    <div class="row outer-box-wrap" v-bind:style="[outerStyle, linkStyle, heightCheck]" @click="changeRoute()" tabindex="0">
      <div class="col-12" v-bind:class="[backGround]">
        <div class="row" v-bind:style="[heightCheck]">
          <div class="col p-3 font-size-15 text-bold" v-bind:class="[titleAlignChange, titleColorChange]">
            <i v-if="icon" class="material-icons" v-bind:class="[iconColorChange]">{{icon}}</i>
            {{title}}
          </div>
        </div>
      </div>
      
      <div class="col-12 text-left" ref="textslot" v-bind:class="[darkMode, backGround, slotCheck]">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      outerStyle: {},
      linkStyle: {}
    }
  },
  props: ['route','url','icon','iconColor','height', 'fontSize', 'bgColor', 'title', 'titleColor', 'titleAlign', 'dark'],
  computed: {
    heightCheck: function() {
      if (this.height === 0 || this.height === undefined) {
        return {
          //empty, let it be default
        };
      } else {
        return {
          'min-height': this.height
        };
      }
    },

    backGround: function() {
      if (this.bgColor === "" || this.bgColor === undefined) {
        return
      } else {
        return "background-color: bg-" + this.bgColor
      }
    },

    iconColorChange: function() {
      if (this.iconColor === "" || this.iconColor === undefined) {
        return
      } else {
        return "color: text-" + this.iconColor
      }
    },

    titleColorChange: function() {
      if (this.titleColor === "" || this.titleColor === undefined) {
        return "color: text-dark"
      } else {
        return "color: text-" + this.titleColor
      }
    },

    titleAlignChange: function() {
      if (this.titleAlign === "" || this.titleAlign === undefined) {
        return "text-align: left;"
      } else {
        switch (this.titleAlign) {
          case "center":
            return "text-align: center"
            break;

          case "right":
            return "text-align: right"
            break;
            
          case "left":
            return "text-align: left"
            break;
        }
      }
    },

    darkMode: function() {
      if (this.dark == "true") {
        return "text-light"
      }
    },
    
    slotCheck: function() {
      //check if description text exists, and add padding if it does
      if (this.$slots.default === "" || this.$slots.default === undefined) {
        return
      }

      return "pb-3"
    }
  },
  mounted: function() {
    this.checkFonts()
  },
  methods: {
    changeRoute: function() {
      if (this.route != null && this.route != "") {
        this.$router.push({path: this.route})
        this.$emit('changeRoute')
      } else {
        window.location.assign(this.url)
      }
    },
    checkFonts: function() {
      if (this.fontSize != null && this.fontSize != "") {
        this.linkStyle = {
          fontSize: this.fontSize + 'em'
        }
      }
    }
  }
}
</script>

<style scoped>

.outer-box-wrap:hover {
  cursor: pointer;
  opacity: 0.8;
}

.inner-text {
  /*font-size: 2.0em;*/
  font-weight: bold;
  /*display: table-cell;*/
  padding: 0 1em;
  /*padding-top: 12%; bottom need to be 0*/
  vertical-align: middle;
}

.inner-text a {
  /*font-size: 2.0em;*/
  font-weight: bold;
}

.inner-text a:hover {
  text-decoration: underline;
}
</style>
